// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"mobile-navigation"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M5 2H19V22H5V2Z"},"nodeName":"path","children":[]},{"attributes":{"id":"fill2","fill":"transparent","d":"M12 7L15 13L12 12.0625L9 13L12 7Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M5 2H19V22H5V2Z","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2"},"nodeName":"g","children":[{"attributes":{"stroke":"currentColor","d":"M12 7L15 13L12 12.0625L9 13L12 7Z","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"stroke":"currentColor","d":"M12 18H12.0039V18.0039H12V18Z","stroke-width":2},"nodeName":"path","children":[]}]}]}]};

@tag('t-icon-mobile-navigation')
export default class MobileNavigationIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'mobile-navigation',
    }
  }
}
